import { render } from "./a_ima.vue?vue&type=template&id=75a1611a"
import script from "./a_ima.vue?vue&type=script&lang=js"
export * from "./a_ima.vue?vue&type=script&lang=js"

import "./a_ima.vue?vue&type=style&index=0&id=75a1611a&lang=less"
script.render = render

export default script